/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_PeriodInputs */

const en_admin_subscriptions_period = /** @type {(inputs: Admin_Subscriptions_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period`)
};

/**
* | output |
* | --- |
* | "Period" |
*
* @param {Admin_Subscriptions_PeriodInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_period = /** @type {((inputs?: Admin_Subscriptions_PeriodInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_PeriodInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_period(inputs)
});
export { admin_subscriptions_period as "admin.subscriptions.period" }